<template>
  <div class="search">
    <b-row>
      <b-col cols="12" xl="12">  
        <div :class="{
            'search-bar': true,
            'active': activo,
            'searching': searching 
          }" v-click-outside="onClickOutside">
          <!-- <b-form> -->
            <b-form-group
              label-for="nombreBusqueda">
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="buscar">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="nombreBusqueda"
                  v-model="nombreBusqueda"
                  class="text-upper"
                  type="text"
                  @focus="onFocus"
                  @keyup.enter.prevent="buscar"/>
              </b-input-group>
              <b-input-group-prepend 
                  class="filter-search-icons clear" 
                  @click="clear">
                <b-input-group-text>
                  <i class="fa fa-remove"></i>
                </b-input-group-text>
              </b-input-group-prepend>
            </b-form-group>
          <!-- </b-form> -->
          <div class="search-result">
            <div v-for="{ id, uuId, nombre, search, eventoId, objetoTipoId } in searchList" :key="uuId">
              <div class="search-item">
                <p @click="consultar(objetoTipoId, id, eventoId)">{{ nombre }}</p>
                <p @click="consultar(objetoTipoId, id, eventoId)" v-if="objetoTipoId == 2" >
                  {{ search }}
                </p>
              </div>
            </div>

            <div class="search-item ver-todos" v-if="showVerTodos">
                <p @click="consultarResultados">{{ showVerTodosLeyenda }}</p>
                <p></p>
              </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';
import Vue2ClickOutside from 'vue2-click-outside';

const { mapFields } = createHelpers({
  getterType: 'searchList/getField',
  mutationType: 'searchList/updateField',
});

export default {
  name: 'SearchBar',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal
  ],
  directives: {
    clickOutside: Vue2ClickOutside.directive
  },  
  data: () => {
    return {
      activo: false,
      searching: false,
      nombreBusqueda: '',
    }
  },
  computed: {
    ...mapFields([
      'searchList',
      'searchListCount',
      'searchListMax',
      'nombre'
    ]),
    showVerTodos() {
      if (this.searchList) {
        if (this.searchListCount > this.searchListMax) {
          return true;
        }
      }
      return false;
    },
    showVerTodosLeyenda() {
      if (this.searchList) {
        if (this.searchListCount > this.searchListMax) {
          return `Ver los ${this.searchListCount} resultados`;
        }
      }
      return '';
    }
  },
  created() {
    this.nombreBusqueda = this.nombre.trim();
  },  
  methods: {
    buscar() {
      if (this.nombreBusqueda.trim() == '') {
        return;
      }
      
      let params = {
        nombre: this.nombreBusqueda.trim()
      }
      this.searching = true;
      this.$store.dispatch('searchList/getSearchList', params)
        .then(() => {
          this.searching = false;
          this.activo = true;
        });
    },
    consultar(objetoTipoId, id, eventoId) {
      this.$store.dispatch('searchList/clear')
        .then(() => {
          switch (parseInt(objetoTipoId)) {
            case 1:
              this.$router.push({ name: 'EventoDatos', 
                                params: { id: id }});
              break;
            case 2:
              this.$router.push({ name: 'ParticipanteDatos', 
                              params: { 
                                eventoId: eventoId, 
                                id: id 
                              }});
              break;
          }
        });
    },
    // consultar(item) {
    //   this.$store.dispatch('searchList/clear')
    //     .then(() => {
    //       switch (parseInt(item.objetoTipoId)) {
    //         case 1:
    //           this.$router.push({ name: 'EventoDatos', 
    //                             params: { id: item.id }});
    //           break;
    //         case 2:
    //           this.$router.push({ name: 'ParticipanteDatos', 
    //                           params: { 
    //                             eventoId: item.eventoId, 
    //                             id: item.id 
    //                           }});
    //           break;
    //       }
    //     });
    // },
    clear() {
      this.$store.dispatch('searchList/clear')
        .then(() => {
          this.nombreBusqueda = '';
          this.activo = false;
        })
    },
    onClickOutside (event) {
      // console.log('Clicked outside. Event: ', event);
      this.activo = false;
    },
    onFocus() {
      if (this.searchList) {
        if (this.searchList.length != 0) {
          this.activo = true;
        }
      }
    },
    onKeydown() {

    },
    consultarResultados() {
      this.$router.push({ name: 'SearchList' });
    },
  }
}
</script>

<style>
.search {
  position: relative;
  margin-bottom: 45px;
  background-color: pink;
}
.search-bar {
  background-color: white;
  border-radius: 30px;
  position: absolute;
  z-index: 99;
  width: 96%;
  left: 2%;
  height: 180px;
  height: 35px;
  overflow: hidden;
  border: none;
}
.search-bar .filter-search-icons div.input-group-text {
  border-radius: 30px !important;
  position: absolute;
  top: 2px;
  left: 10px;
  z-index: 99;
  background-color: transparent;  
  border: 1px solid transparent;
  padding: 0.5rem;
}
.search-bar .filter-search-icons.clear div.input-group-text {
  left: 96%;
}

.search-bar #nombreBusqueda {
  border-radius: 30px !important;
  padding-left: 55px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #f0f3f5;
}
.search-bar #nombreBusqueda:focus {
  box-shadow: none;
  background-color: #fff;
}
.search-bar.searching #nombreBusqueda {
  cursor: progress;
}
.search-bar .search-result {
  /* border: 1px solid red; */
  height: 70%;
  padding-left: 20px;
  padding-right: 20px;
  overflow-y: auto;
}
.search-bar .search-result .search-item {
  /* border: 1px solid red; */
  margin-bottom: 10px;
}
.search-bar .search-result .search-item p {
  cursor: pointer;
}
.search-bar .search-result .search-item p:first-child {
  font-size: 0.8em;
  font-weight: 500;
  /* color: blue; */
  margin-bottom: 0;
  color: #20a8d8;
}
.search-bar .search-result .search-item p:last-child {
  font-size: 0.8em;
  /* font-weight: 400; */
  /* color: green; */
  margin-bottom: 0;
}
.search-bar .search-result .search-item.ver-todos p:first-child {
  color: #5c6873;
}
.search-bar .search-result table {
  max-height: 90%;
}
.search-bar .search-result thead {
  display: none;
}
.search-bar .search-result table tbody > tr > td {
  cursor: pointer;
  font-size: 0.8em;
}
.search-bar .search-result table td {
  border-top: none;
  padding-top: 5px;
  padding-bottom: 5px; 
}
.search-bar .search-result table td[aria-colindex="1"] {
  width: 100%;
}
/* .search-bar .search-result table td[aria-colindex="1"] {
  width: 10%;
}
.search-bar .search-result table td[aria-colindex="2"] {
  width: 90%;
} */
.search-bar .filter-search-icons div.input-group-text:hover {
  border-color: #e4e7ea;
}
.search-bar.active {
  height: 220px;
  border: 1px solid lightgray;
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.05);
  -webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.05);
  -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.05);  
}
.search-bar.active #nombreBusqueda {
  border: none;
  background-color: #fff;
}
</style>
